/**
 * @Author: chengzh
 * @Date:   2021-07-07 10:05:16
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-09-15 11:28:32
 */

const isProd = !!(process.env.NODE_ENV === 'production');

// 统一的环境配置
const ecosystemEnv = {
  dev: 'http://192.168.130.58:8088/gw',
  dev76: 'http://192.168.136.58:8080/apigw/',
  dev1: 'http://192.168.127.12:8080/apigw/',
  test: 'http://192.168.130.58:8088/gw',
  sandbox: 'https://celer-gateway.lianlianpay-inc.com',
  production: 'https://secure-checkout.lianlianpay.com/gw',
};

module.exports = {
  // pm2 配置
  apps: [
    {
      name: 'celerpay-checkout-counter',
      script: 'server.js',
      instances: 'max',
      exec_mode: 'cluster',
      max_memory_restart: '1024M',
      
      // 日志配置
      out_file: isProd ? '/usr/log/applog/celerpay-checkout-counter-out.log' : './logs/null',
      error_file: isProd ? '/usr/log/applog/celerpay-checkout-counter-error.log' : './logs/null',
      pid_file: isProd ? '/usr/log/applog/celerpay-checkout-counter-pid.log' : './logs/null',
      log_date_format: 'YYYY-MM-DD HH:mm:ss Z',
      
      // 日志轮转配置
      max_size: '20M',
      log_type: 'json',
      log_level: 'info',
      
      // 各个环境配置，引用统一的环境变量
      env: {
        NODE_ENV: 'dev',
        PORT: '8085',
        HOST: ecosystemEnv.dev, 
      },
      
      env_dev76: {
        NODE_ENV: 'dev76',
        PORT: '8085',
        HOST: ecosystemEnv.dev76, 
      },
      
      env_dev1: {
        NODE_ENV: 'dev1',
        PORT: '8085',
        HOST: ecosystemEnv.dev1, 
      },
      
      env_test: {
        NODE_ENV: 'test',
        PORT: '8085',
        HOST: ecosystemEnv.test, 
      },
      
      env_sandbox: {
        NODE_ENV: 'sandbox',
        APP_ENV: 'sandbox',
        PORT: '8085',
        HOST: ecosystemEnv.sandbox,
      },
      
      env_production: {
        NODE_ENV: 'production',
        PORT: '8085',
        HOST: ecosystemEnv.production,
      },
    },
  ],
  // 保持向后兼容的环境配置导出
  ...ecosystemEnv,
};


